/**
 * Created by Anup on 8/7/2019.
 */
function closebtnWish(that){
    console.log("remove product from wishlist");
};

$(document).ready(function(){
// Set Browser Cookies
    function setCookie(cname,cvalue,exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }



// Get Browser Cookies
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function getParameterByName(name) {
        url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var ProductIDonPDP = $('.wishlist').attr("id");
    if(ProductIDonPDP != undefined){
        var Pro_ID = checkProductVariantIsSelected(ProductIDonPDP);
        hideWishlistBtn(Pro_ID);
    }

// Check if Customer is login or Not
    if(c_id == ''){
//     var showproducts = getCookie("wishlist_products");
//     manageWishlistBtnOnCollectionPage(showproducts);
//     setCookie("_wl_p_customer", '', 30);
//     showProductsInSidebarMenu(showproducts);
    }else {
//     var products = getCookie("wishlist_products");
//     if(products != ''){
//       $.ajax({
//         type:'POST',
//         url:' https://mylyrics.in/api.oscp.com/server.php/api/wishlist/update',
//         data:'s_id='+s_id+'&c_id='+c_id+'&p_list='+products,
//         crossDomain : true,
//         success:function(data){
//           setCookie("wishlist_products", '', 30);
//           showProductsInSidebarMenu(data.data);
//           setCookie("_wl_p_customer", data.data, 30);
//         }
//       });
//     }else{
//       $.ajax({
//         type:'POST',
//         url:'https://mylyrics.in/api.oscp.com/server.php/api/wishlist/show',
//         data:'s_id='+s_id+'&c_id='+c_id,
//         crossDomain : true,
//         success:function(data){
//          // if(data.data != 'null'){
//             showProductsInSidebarMenu(data.data);
//             setCookie("_wl_p_customer", data.data, 30);
//             manageWishlistBtnOnCollectionPage(data.data);

//           //}
//         }
//       });
//     }
    }

    function manageWishlistBtnOnCollectionPage(showproducts){

        var arr = showproducts.split('|');
        $(".wishlist_collection").each(function(){
            var flag = 0;
            for (var i = 0; i < arr.length; i++) {
                if(arr[i] == this.id){
                    $( this ).hide();
                    $( this ).parent().parent().find('.remove_wishlist_collection').show();
                    flag = 1;
                }
            }
            if (flag != 1) {
                $( this ).show();
                $( this ).parent().parent().find('.remove_wishlist_collection').hide();
            }
        });
    }

// function to check product variant is selected or Not
    function checkProductVariantIsSelected(id){
        var Pro_ID;
        var variantID = getParameterByName('variant');
        if(variantID != null){
            Pro_ID = id + ',' + variantID;
        }else{
            Pro_ID = id;
        }
        return Pro_ID;
    }
// Add to cart from Wishlist page

    $(document).on("click", ".add_to_cart", function() {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { quantity: 1, id: this.id},
            success: function(){
                console.log("product added");
                location.reload();
            }
        });

    });
//// collection page  add remove product ////

// Add Product to Wishlist
    $(".wishlist_collection").click(function(){
        $( this ).hide();
        $( this ).parent().parent().find('.remove_wishlist_collection').show();
        if(c_id == ''){
            var Pro_ID = checkProductVariantIsSelected(this.id);
            addProductToCookies(Pro_ID);
        }else {
            var Pro_ID = checkProductVariantIsSelected(this.id);
            addProductToCustomerMeta(Pro_ID);
        }
    });

//  Remove Product from Wishlist
    $(".remove_wishlist_collection").click(function() {
        if(c_id == ''){
            $( this ).hide();
            $( this ).parent().parent().find('.wishlist_collection').show();
            var Pro_ID = checkProductVariantIsSelected(this.id);
            removeProductFromCookies(Pro_ID);
            var showproducts = getCookie("wishlist_products");
            showProductsInSidebarMenu(showproducts);
        }else{
            var Pro_ID = checkProductVariantIsSelected(this.id);
            removeProductFromCustomerMeta(Pro_ID);
        }
    });


////////

// Add Product to Wishlist

    $(".wishlist").click(function(){
        if(c_id == ''){
            var Pro_ID = checkProductVariantIsSelected(this.id);
            addProductToCookies(Pro_ID);
        }else {
            var Pro_ID = checkProductVariantIsSelected(this.id);
            addProductToCustomerMeta(Pro_ID);
        }
    });

//  Remove Product from Wishlist
    $(".remove_wishlist").click(function() {
        if(c_id == ''){
            var Pro_ID = checkProductVariantIsSelected(this.id);
            removeProductFromCookies(Pro_ID);
            var showproducts = getCookie("wishlist_products");
            showProductsInSidebarMenu(showproducts);
        }else{
            console.log(this.id);
            var Pro_ID = checkProductVariantIsSelected(this.id);
            removeProductFromCustomerMeta(Pro_ID);
        }
    });

    $(document).on("click", ".wishlistproduct .closeBtn", function() {
        if(c_id == ''){
            manageWishlistBtnFromSidebar(this.id);
            removeProductFromCookies(this.id);
            var showproducts = getCookie("wishlist_products");
            manageWishlistBtnOnCollectionPage(showproducts);
            showProductsInSidebarMenu(showproducts);
            showProductsOnWishlistPage(showproducts);

        }else{
            manageWishlistBtnFromSidebar(this.id);
            removeProductFromCustomerMeta(this.id);

        }
    });

// Remove Product From Customer Metafield
    function removeProductFromCustomerMeta(id){
        var pid = id;
        $.ajax({
            type:'POST',
            url:' https://mylyrics.in/api.oscp.com/api/wishlist/remove',
            data:'s_id='+s_id+'&c_id='+c_id+'&p_name='+pid,
            crossDomain : true,
            success:function(data){
                showProductsInSidebarMenu(data.data);
                showProductsOnWishlistPage(data.data);
                setCookie("_wl_p_customer", data.data, 30);
                manageWishlistBtnOnCollectionPage(data.data);
            }
        });
    }

// Remove Product from cookie
    function removeProductFromCookies(id){
        var pid = id;
        var get_products = getCookie("wishlist_products");
        var arrr = get_products.split('|');
        for(var i = 0; i < arrr.length; i++) {
            if (arrr[i] != '') {
                if(arrr[i] == pid) {
                    idval = pid+"|";
                    var res = get_products.replace(idval, '');
                    setCookie("wishlist_products", res, 30);
                }
            }
        }
    }

// Add Products to Custore Meta
    function addProductToCustomerMeta(id){
        var pid = id;
        $.ajax({
            type:'POST',
            url:' https://mylyrics.in/api.oscp.com/api/wishlist/add',
            data:'s_id='+s_id+'&c_id='+c_id+'&p_name='+pid,
            crossDomain : true,
            success:function(data){
                showProductsInSidebarMenu(data.data);
                setCookie("_wl_p_customer", data.data, 30);
            }
        });
    }

// On change the variant function

    $('.single-option-selector-product-template').on('change', function() {
        var ProductIDonPDP = $('.wishlist').attr("id");
        var Pro_ID = checkProductVariantIsSelected(ProductIDonPDP);
        //var products = getCookie("wishlist_products");
        var products = '';
        if(c_id == ''){
            products = getCookie("wishlist_products");
        }else{
            products = getCookie("_wl_p_customer");
        }

        if(products.length > 1){
            var arrrr = products.split('|');
            var arrrr = arrrr.filter( Boolean );
            var flag = 0;
            for(var i = 0; i < arrrr.length; i++) {
                if(arrrr[i] == Pro_ID){
                    $('.wishlist').hide();
                    $('.remove_wishlist').show();
                    flag = 1;
                }
            }
            if(flag != 1){
                $('.wishlist').show();
                $('.remove_wishlist').hide();
            }
        }

    });

////
    function hideWishlistBtn(id){
        var products = '';
        if(c_id == ''){
            products = getCookie("wishlist_products");
        }else{
            products = getCookie("_wl_p_customer");
        }
        var arrrr = products.split('|');
        var arrrr = arrrr.filter( Boolean );

        var flag = 0;
        for(var i = 0; i < arrrr.length; i++) {
            if(arrrr[i] == id){
                $('.wishlist').hide();
                flag = 1;
            }
        }
        if(flag != 1){
            $('.wishlist').show();
            $('.remove_wishlist').hide();
        }

    }



    function manageWishlistBtnFromSidebar(id){

        var products = '';
        if(c_id == ''){
            products = getCookie("wishlist_products");
        }else{
            products = getCookie("_wl_p_customer");
        }
        var arrrr = products.split('|');
        var arrrr = arrrr.filter( Boolean );
        var flag = 0;
        var v_pro = id.split(',');
        var checkPage = getParameterByName('variant');
        if(v_pro.length <= 2){
            if(checkPage == null){
                for(var i = 0; i < arrrr.length; i++) {
                    if(arrrr[i] == id){
                        $('.wishlist').show();
                        $('.remove_wishlist').hide();
                    }
                }
            }

        }else{
            if(checkPage != null){
                for(var i = 0; i < arrrr.length; i++) {
                    var v_id = arrrr[i].split(',');
                    if(v_pro[2] == checkPage){
                        $('.wishlist').show();
                        $('.remove_wishlist').hide();
                    }
                }
            }
        }
        for(var i = 0; i < arrrr.length; i++) {

            /*
             if(arrrr[i] == Pro_ID){
             var variantID = getParameterByName('variant');
             }
             */
        }
    }

// Add Products to Cookie
    function addProductToCookies(id){
        var pid = id;
        var products = getCookie("wishlist_products");
        var all_product = '';
        var flag = 0;
        if (products.length == 0) {
            var id = pid+"|";
            setCookie("wishlist_products", id, 30);
            var showproducts = getCookie("wishlist_products");
            showProductsInSidebarMenu(showproducts);
        } else {
            var arr = products.split('|');
            for(var i = 0; i < arr.length; i++) {
                if(arr[i] == pid){
                    var flag = 1;
                    console.log("already in wishlist");
                    return false;
                }
            }
            if(flag != 1) {
                all_product = products + pid +'|';
                setCookie("wishlist_products", all_product, 30);
                console.log("Product added to wishlist");
                var showproducts = getCookie("wishlist_products");
                showProductsInSidebarMenu(showproducts);
            }
        }
    }

// Show Product From Browser Cookies If Customer is Not Login.
    function showProductsInSidebarMenu(showproducts){
        $('.wishlistproduct').remove();
        var arrrr = showproducts.split('|');
        var arrrr = arrrr.filter( Boolean );
        for(var i = 0; i < arrrr.length; i++) {
            var v_ids = '';
            if(arrrr[i] != ''){
                $('#emptyMsg').hide();
                var product_id = arrrr[i].split(',');
                /***/
                getProductData(product_id)
                /***/
            }
        }
        if(showproducts == '' || showproducts == 'null'){
            $('#emptyMsg').show();
            $('#wishlistImgCount').remove();
            $('#product_count').append("<span id='wishlistImgCount'><h5 id='itm'> 0 <h5></span>");
            $('#sendBtn').hide();
        }else{
            $('#wishlistImgCount').remove();
            console.log((arrrr.length));
            $('#product_count').append("<span id='wishlistImgCount'><h5 id='itm'>"+ ((arrrr.length)) +" <h5></span>");
            $('#sendBtn').show();
        }

    }

    function getProductData(ids){
        if(ids != 'null' && ids != ''){
            jQuery.getJSON('/products/'+ids[0]+'.js', function(product) {
                getProductDataCallback(product, ids);
            });
        }

    }

    function getProductDataCallback(product, ids){

        if(ids.length == 3){
            v_ids = ids[2];
            var variants = product.variants;
            for (var j = 0; j < variants.length ; j++) {
                var  V_Products = '';
                if(variants[j].id == v_ids){
                    V_Products = variants[j];

                    var optionName = '';
                    var Ind = 0;
                    var VARPRO = '';
                    for(var k = 0; k < product.options.length; k++){
                        Ind = Ind+1;
                        KEY = 'option'+Ind;
                        VARPRO = VARPRO + "<div class='p_sku'> <span>"+ product.options[k].name + " : </span> "+  V_Products[KEY] +"</div>";
                    }

                    $(".wishlist_sidebar").append("<div class='wishlistproduct'>   <div class='productDetails'> <div class='wishlistimg'> <a href='/products/"+product.handle+"?variant="+V_Products.id+"'>  <img src='"+ Shopify.resizeImage(V_Products.featured_image.src,'200x200') +"'/>   </div> <div class='pricecontent'> <h3>"+product.title+"</h3> <div class='p_price'> "+Shopify.formatMoney(V_Products.price, '{{amount}}') +" </div> <div class='p_sku'> <span>SKU:</span> "+V_Products.sku+" </div> "+ VARPRO +" </div> </div> </a> <div class='removePro'> <a onclick='closebtnWish(this);' class='closeBtn' id='"+product.handle+ "," +product.id+","+V_Products.id+"'> X </a></div> </div>");
                }
            }
        }else{
            var ind = 0;
            var key = '';
            var VarPor = '';
            if(product.variants.length > 1){
                for(var q=0; q < product.options.length; q++){
                    ind = ind+1;
                    key = 'option'+ind;
                    VarPor = VarPor + "<div class='p_sku'> <span>"+ product.options[q].name + " : </span> "+  product.variants[0][key] +"</div>";
                }
            }else if (product.options[0].values[0] != 'Default Title' ){
                VarPor = "<div class='p_sku'> <span>"+ product.options[0].name + " : </span> "+  product.variants[0].option1 +"</div>";;
                //console.log("tetstst ==="+VarPor);
            }else {
                VarPor = '';
            }


            $(".wishlist_sidebar").append("<div class='wishlistproduct'>  <div class='productDetails'> <div class='wishlistimg'> <a href='/products/"+product.handle+"'> <img src='"+ Shopify.resizeImage(product.featured_image,'200x200') +"'/>  </div> <div class='pricecontent'> <h3>"+product.title+"</h3> <div class='p_price'> "+ Shopify.formatMoney(product.price, '{{amount}}') +" </div>  <div class='p_sku'> <span>SKU:</span> "+product.variants[0].sku+"  </div> "+ VarPor +" </div>  </div> </a>  <div class='removePro'>  <a onclick='closebtnWish(this);' class='closeBtn' id='"+product.handle+ "," +product.id+"'> X </a></div> </div>");
        }
    }

// show product in page
    function showProductsOnWishlistPage(showproducts){
        $('.wishlistItem').remove();
        var arrrr = showproducts.split('|');
        for(var i = 0; i < arrrr.length; i++) {
            if(arrrr[i] != '' ){
                var product_id = arrrr[i].split(',');
                if(product_id.length == 3){
                    jQuery.getJSON('/products/'+product_id[0]+'.js', function(product) {
                        var variants = product.variants;
                        for (var i = 0; i < variants.length ; i++) {
                            var V_Product = '';
                            if(variants[i].id == product_id[2]){
                                V_Product = variants[i];
                                jQuery.getJSON('/products/'+product_id[0]+'.js', function(product) {
                                    $(".wishlist_product_container").append("<div class= 'wishlistItem'><div class='wishlistPImg'>  <a href='/products/"+product.handle+"?variant="+V_Product.id+"'> <img src='"+ V_Product.featured_image.src+"'/> </a> </div> <div class='productDetails'> <h3>"+product.title+"  </h3> <div class='p_price'> <span>Price:</span> "+Shopify.formatMoney(V_Product.price, '{{amount}}')+" </div> <div class='p_sku'> <span>SKU: </span> "+V_Product.sku+" </div><div class='add_to_cart'> add to cart </div> </div> <span class='closeBtn' id='"+product.handle+ "," +product.id+","+V_Product.id+"'> X </span> </div>");
                                });
                            }
                        }
                    });
                }else if(product_id.length == 2) {
                    jQuery.getJSON('/products/'+product_id[0]+'.js', function(product) {
                        $(".wishlist_product_container").append("<div class= 'wishlistItem'><div class='wishlistPImg'>  <a href='/products/"+product.handle+"'> <img src='"+product.featured_image+"'/> </a> </div> <div class='productDetails'> <h3>"+product.title+"  </h3> <div class='p_price'> <span>Price:</span> "+ Shopify.formatMoney(product.price, '{{amount}}')+" </div> <div class='p_sku'> <span>SKU: </span> "+product.variants[0].sku+" </div><div class='add_to_cart'> add to cart </div> </div> <span class='closeBtn' id='"+product.handle+ "," +product.id+"'> X </span> </div>");
                    });
                }
            }
        }
    }

});

function openNav() {
    $( "#siderNav" ).animate({ "left": "+=320px" }, 100 );
    $('.wishlist-bg').show();
}

function closeNav() {
    $( "#siderNav" ).animate({ "left": "-=320px" }, 1 );
    $('.wishlist-bg').hide();
}

